<template>
  <!-- 운전/정지 이력 -->
  <v-container fluid>
    <v-row class="justify-end">
      <v-spacer></v-spacer>
      <v-col class="d-inline-flex align-center align-content-space-around">
        <div v-if="this.ONOFFYN === 'Y'">
          <v-btn class="invControl" v-on:click="inverterOn()">Inverter ON</v-btn>
          <v-btn class="invControl" v-on:click="inverterOff()">Inverter OFF</v-btn>
        </div>
        <v-btn small outlined class="default-btn mr-4" @click="prevMonth">1개월</v-btn>
        <date-picker :date.sync="startDate"></date-picker>
        <span class="mx-4">~</span>
        <date-picker :date.sync="endDate"></date-picker>
        <v-btn small outlined class="default-btn mx-4" @click="retrieveGrid">조회</v-btn>
        <v-btn small outlined class="excel_down" @click="excelDown">엑셀 다운로드</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <real-grid
          ref="dataGrid"
          class="mt-1 mb-5 w-full"
          :options="grid.gridOption"
          :fields="grid.gridFields"
          :columns="grid.gridColumns"
          :height="grid.height"
          :retrieve-api="gridRetrieveApi"
        ></real-grid>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { getWorkRecord } from '@/api/pcs/siteWork'
import DatePicker from '@/components/monitoring/DatePicker'
import day from 'dayjs'
import RealGrid from '@/components/grid/Realgrid'
import Message from '@/utils/message'
import { getSiteDetail } from '@/api/master/master'
import { getConnect } from '@/api/master/mqtt'

export default {
  components: {
    DatePicker,
    RealGrid
  },
  props: {
    tabIndex: {
      type: Number,
      default: -1
    },
    SITE_ID: { type: String, default: '' },
    INVERTER_ID: { type: String, default: '' },
    STATION_ID: { type: String, default: '' },
    ONOFFYN: { type: String, default: '' }
  },
  data() {
    return {
      serial: [],
      endDate: day().format('YYYY-MM-DD'),
      startDate: day()
        .add(-6, 'day')
        .format('YYYY-MM-DD'),
      grid: {
        height: 442.5,
        gridOption: {
          gridView: {
            edit: {
              appendable: true,
              insertable: true,
              deletable: true
            },
            setGroupingOptions: {
              enabled: false // header 그룹핑 옵션을 사용하지 않는다.
            },
            checkBar: {
              visible: false
            },
            panel: {
              visible: false
            },
            display: {
              // 그리드 너비에 맞춰 컬럼 너비 자동 조정
              fitStyle: 'even'
            }
          },
          dataProvider: {
            softDeleting: true,
            // 해당 옵션이 false 이면 추가된 행을 삭제했을 경우 -+ 표시가 생긴다.
            // true 이면 추가된 행은 바로 삭제, 기존에 존재하던 행은 - 표시
            deleteCreated: true
          }
        },
        gridFields: [
          { fieldName: 'Date', dataType: 'string' },
          { fieldName: 'Time', dataType: 'string' },
          { fieldName: 'Inverter_No', dataType: 'string' },
          { fieldName: 'Run_Status', dataType: 'string' }
        ],
        gridColumns: [
          {
            name: 'Date',
            fieldName: 'Date',
            header: {
              text: '일자'
            },
            styles: {
              background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
            },
            // editable 옵션이 false 일 경우, 수정할 수 없다.
            editable: false
          },
          {
            name: 'Time',
            fieldName: 'Time',
            header: {
              text: '시간'
            },
            styles: {
              textAlignment: 'center'
            }
          },
          {
            name: 'Inverter_No',
            fieldName: 'Inverter_No',
            header: {
              text: '인버터 번호'
            },
            styles: {
              textAlignment: 'center',
              background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
            }
          },
          {
            name: 'Run_Status',
            fieldName: 'Run_Status',
            header: {
              text: '이력'
            },
            renderer: {
              type: 'icon',
              iconCallback: function(grid, cell) {
                let image =
                  cell.value === '운전' || cell.value === '대기'
                    ? 'green'
                    : 'red'
                return `/external/runImage/running_${image}.png`
              },
              iconHeight: 15,
              iconWidth: 15
            },
            styles: {
              background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
            }
          }
        ]
      }
    }
  },
  mounted() {},
  computed: {
    gridRetrieveApi() {
      return this.retrieveApi
    }
  },
  watch: {
    tabIndex() {
      this.clearGrid()
    }
  },
  methods: {
    inverterOn() {
      if (this.INVERTER_ID === null || this.INVERTER_ID === '') {
        alert('인버터별 탭에서 실행해 주세요')
        return
      }
      let serial = ''
      let params = {
        codenm: this.SITE_ID
      }

      getSiteDetail(params).then(response => {
        const validModels = [
          'HPC-036HL-V1-OU',
          'HPC-036HL-V2-OU',
          'HPC-036HL-V3-OU',
          'HPC-060HL-D1-OU',
          'HPC-060HL-D2-OU',
          'HPC-060HL-D3-OU'
        ]
        const model = response.stations[this.STATION_ID - 1].inverters[this.tabIndex - 1].model
        const serialValue = response.stations[this.STATION_ID - 1].inverters[this.tabIndex - 1].serial
        serial = validModels.includes(model) ? serialValue : '000' + serialValue

        if (confirm('시리얼넘버 ' + serial + ' 인버터를 실행합니다')) {
          let json = null
          let obj2 = null

          let obj = { sn: '0001015642049840' }
          let blob = new Blob([JSON.stringify(obj, null, 2)], {
            type: 'application/json'
          })

          let xhr = new XMLHttpRequest()
          xhr.open(
            'GET',
            'https://api-a.fomware.com/asset/v1/list?key=' +
              serial +
              '&type=2'
          )
          xhr.setRequestHeader('Content-Type', 'application/json')
          // xhr.setRequestHeader('Accept', 'application/json')
          // xhr.setRequestHeader('X-APIVERSION', 'v1.0')
          xhr.setRequestHeader(
            'Authorization',
            'Bearer VOgCWgFeNGNVXCFlCXurfyCEtmdqmkAk'
          )
          xhr.send(blob)
          // let jsondata = JSON.parse(xhr.responseText)
          xhr.onreadystatechange = function() {
            if (xhr.readyState === XMLHttpRequest.DONE) {
              // alert(xhr.responseText)
              // alert(jsondata)
              json = xhr.response
              obj2 = JSON.parse(json)
              console.log(obj2.data.devices[0].deckId)
              console.log(obj2.data.devices[0].xBusId)

              let obj4 = {
                count: 1,
                startAddress: '2700',
                value: '5555',
                deviceCode: [
                  obj2.data.devices[0].deckId +
                    '-' +
                    obj2.data.devices[0].xBusId
                ]
              }
              let blob2 = new Blob([JSON.stringify(obj4, null, 2)], {
                type: 'application/json'
              })

              let xhr2 = new XMLHttpRequest()
              xhr2.open('POST', 'https://api-a.fomware.com/register/v1/write')
              xhr2.setRequestHeader('Content-Type', 'application/json')
              // xhr.setRequestHeader('Accept', 'application/json')
              // xhr.setRequestHeader('X-APIVERSION', 'v1.0')
              xhr2.setRequestHeader(
                'Authorization',
                'Bearer VOgCWgFeNGNVXCFlCXurfyCEtmdqmkAk'
              )
              xhr2.send(blob2)
              // xhr.send(JSON.stringify(obj))
              // let jsondata = JSON.parse(xhr.responseText)
              xhr2.onreadystatechange = function() {
                if (xhr2.readyState === XMLHttpRequest.DONE) {
                  // alert(xhr.responseText)
                  // alert(jsondata)
                  // json = xhr.response
                  // obj2 = JSON.parse(json)
                  // console.log(json)
                  alert('작업 완료. 인버터 적용까지 최대 5분 소요 됩니다.')
                }
              }
            }
          }
        } else {
          alert('실행 취소')
        }
      })
    },
    inverterOff() {
      if (this.INVERTER_ID == null || this.INVERTER_ID === '') {
        alert('인버터별 탭에서 실행해 주세요')
      } else {
        let serial = ''
        let params = {
          codenm: this.SITE_ID
        }
        getSiteDetail(params).then(response => {
          const validModels = [
            'HPC-036HL-V1-OU',
            'HPC-036HL-V2-OU',
            'HPC-036HL-V3-OU',
            'HPC-060HL-D1-OU',
            'HPC-060HL-D2-OU',
            'HPC-060HL-D3-OU'
          ]
          const model = response.stations[this.STATION_ID - 1].inverters[this.tabIndex - 1].model
          const serialValue = response.stations[this.STATION_ID - 1].inverters[this.tabIndex - 1].serial
          serial = validModels.includes(model) ? serialValue : '000' + serialValue

          if (confirm('시리얼넘버 ' + serial + ' 인버터를 종료 합니다')) {
            let json = null
            let obj2 = null

            let obj = { sn: '0001015642049840' }
            let blob = new Blob([JSON.stringify(obj, null, 2)], {
              type: 'application/json'
            })

            let xhr = new XMLHttpRequest()
            xhr.open(
              'GET',
              '   https://api-a.fomware.com/asset/v1/list?key=' +
                serial +
                '&type=2'
            )
            xhr.setRequestHeader('Content-Type', 'application/json')
            // xhr.setRequestHeader('Accept', 'application/json')
            // xhr.setRequestHeader('X-APIVERSION', 'v1.0')
            xhr.setRequestHeader(
              'Authorization',
              'Bearer VOgCWgFeNGNVXCFlCXurfyCEtmdqmkAk'
            )
            xhr.send(blob)
            // let jsondata = JSON.parse(xhr.responseText)
            xhr.onreadystatechange = function() {
              if (xhr.readyState === XMLHttpRequest.DONE) {
                // alert(xhr.responseText)
                // alert(jsondata)
                json = xhr.response
                obj2 = JSON.parse(json)
                console.log(obj2.data.devices[0].deckId)
                console.log(obj2.data.devices[0].xBusId)

                let obj4 = {
                  count: 1,
                  startAddress: '2700',
                  value: '7777',
                  deviceCode: [
                    obj2.data.devices[0].deckId +
                      '-' +
                      obj2.data.devices[0].xBusId
                  ]
                }
                let blob2 = new Blob([JSON.stringify(obj4, null, 2)], {
                  type: 'application/json'
                })

                let xhr2 = new XMLHttpRequest()
                xhr2.open(
                  'POST',
                  'https://api-a.fomware.com/register/v1/write'
                )
                xhr2.setRequestHeader('Content-Type', 'application/json')
                // xhr.setRequestHeader('Accept', 'application/json')
                // xhr.setRequestHeader('X-APIVERSION', 'v1.0')
                xhr2.setRequestHeader(
                  'Authorization',
                  'Bearer VOgCWgFeNGNVXCFlCXurfyCEtmdqmkAk'
                )
                xhr2.send(blob2)
                // xhr.send(JSON.stringify(obj))
                // let jsondata = JSON.parse(xhr.responseText)
                xhr2.onreadystatechange = function() {
                  if (xhr2.readyState === XMLHttpRequest.DONE) {
                    // alert(xhr.responseText)
                    // alert(jsondata)
                    // json = xhr.response
                    // obj2 = JSON.parse(json)
                    // console.log(json)
                    alert('작업 완료. 인버터 적용까지 최대 5분 소요 됩니다.')
                  }
                }
              }
            }
          } else {
            alert('실행 취소')
          }
        })
      }
    },
    clearGrid() {
      this.$refs.dataGrid.getDataProvider().clearRows()
    },
    retrieveGrid() {
      this.$refs.dataGrid.retrieve()
    },
    retrieveApi() {
      if (this.SITE_ID == '' || this.SITE_ID == null) {
        alert('사이트를 먼저 검색해주세요.')
        return
      }

      let diffDay = day(this.endDate).diff(this.startDate, 'day')
      if (diffDay < 0 || diffDay > 31) {
        Message.err('조회 불가능 날짜입니다.')
        return
      }

      return new Promise((resolve, reject) => {
        let params = {}
        if (this.INVERTER_ID == null || this.INVERTER_ID === '') {
          params =
            '/' +
            this.SITE_ID +
            '/' +
            this.startDate +
            '/' +
            this.endDate +
            '/' +
            0 +
            '/' +
            0
        } else {
          params =
            '/' +
            this.SITE_ID +
            '/' +
            this.startDate +
            '/' +
            this.endDate +
            '/' +
            this.INVERTER_ID +
            '/' +
            this.STATION_ID
        }
        getWorkRecord(params).then(res => {
          resolve(res.workRecord)
        })
      })
    },

    prevMonth() {
      // 날짜선택
      if (this.endDate === '' || this.endDate == null) {
        this.startDate = day(this.endDate)
          .add(-31, 'day')
          .format('YYYY-MM-DD')
        this.endDate = day().format('YYYY-MM-DD')
      } else {
        this.startDate = day(this.endDate)
          .add(-31, 'day')
          .format('YYYY-MM-DD')
      }
    },

    excelDown() {
      let gridView = this.$refs.dataGrid.getGridView()
      // 엑셀다운로드
      gridView.exportGrid({
        type: 'excel',
        target: 'local',
        fileName: '운전/정지이력_' + day().format('YYYY-MM-DD') + '.xlsx',
        indicator: 'visible',
        footer: 'hidden',
        header: 'visible',
        allColumns: true,
        done: function() {
          Message.success('출력이 완료되었습니다.')
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
.invControl {
  margin-right: 10px;
}
</style>
